import { ApiError } from '@/errors/apiError';
import { BaseError } from '@/errors/baseError';

export const normalizeError = (error: unknown) => {
    if (error instanceof ApiError) {
        return error;
    }
    if (error instanceof BaseError) {
        return error;
    }
    if (error instanceof Error) {
        return new BaseError(error.message, error);
    }
    return new BaseError('An unknown error occurred', error);
};
